import { noop } from 'underscore';
import { logged_in as loggedIn } from 'state';
import { bootSeo } from 'booters';

export default () => {
  if (loggedIn()) return;

  const path = window.location.pathname;

  bootSeo().then(() => {
    if (path === window.location.pathname) {
      window.reduxState.store.actionDispatchers.seo.setPrerenderReady();
    }
  }).catch(noop);
};
